import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import { Link as ContentLink, getLinks } from 'features/contents/contentsAPI';

export default function Formularios() {
  const [links, setLinks] = useState<ContentLink[]>([]);

  useEffect(() => {
    getLinks('formularios')
      .then(setLinks)
      .catch(err => {
        console.error(err);
        setLinks([]);
      });
  }, []);

  return (
    <div className="content">
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader>
              <Row>
                <Col style={{ fontSize: '1.5rem', marginTop: '10px' }}>Formularios para Facturar</Col>
              </Row>
            </CardHeader>
            <CardBody>
              {
                links.length === 0
                  ? <p>No hay formularios cargados.</p>
                  : (
                      <ul>
                        {
                          links.map(link => (
                            <li key={ link.id }>
                              <a href={ link.url } target="_blank" rel="noopener noreferrer">{ link.name }</a>
                            </li>
                          ))
                        }
                      </ul>
                    )
              }
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
